import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useSignatures } from './sign-documents-hooks';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { SignatureRow } from './components/SignatureRow';

const useStyles = makeStyles((theme: any) => ({
  container: { width: '100%', padding: theme.spacing(3) },
  mainContainer: {
    backgroundColor: 'white',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: theme.spacing(3),
  },
  title: {
    fontSize: "1.8rem",
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  documentsContainer: {
    margin: '32px 0',
    padding: '0 32px',
  },
  rowContainer: { borderLeft: '4px solid #cfd8dc' },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  headerCell: {
    backgroundColor: "#fafafa",
    color: "#607d8b",
    textAlign: "left",
    fontSize: "16px",
    fontWeight: "bold"
  },
  tableContainer: {
    padding: 0, marginTop: '1rem'
  },
  tableRow: {
    height: '68px'
  }
}));

type Props = {
  query: string
}

export const SignDocuments: FC<Props> = ({ query }) => {
  const {
    signatures,
    handleDownload
  } = useSignatures({ query });

  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <TableContainer className={classes.tableContainer}>
      <Table>
        <TableHead>
          <TableRow className={classes.tableRow}>
            <TableCell className={classes.headerCell}>
              {t("documents:name")}
            </TableCell>
            <TableCell className={classes.headerCell}>
              {t("documents:date")}
            </TableCell>
            <TableCell className={classes.headerCell}>
              {t("documents:signature-from")}
            </TableCell>
            <TableCell className={classes.headerCell}>
              {t("documents:notes")}
            </TableCell>
            <TableCell className={classes.headerCell}>
              {t("documents:status")}
            </TableCell>
            <TableCell className={classes.headerCell}>
              {t("documents:options")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {signatures.map((signature) => (<SignatureRow t={t} signature={signature} handleDownload={handleDownload} />))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
